import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../components/common/SvgIcon';
import UserManagementStore from '../../stores/UserManagementStore';
import EgainActionCreator from '../../actions/EgainActionCreator';
import { getChat } from '../../egainChat/eGainChat';
import { getSMEChat } from '../../egainChat/eGainChatSME';
import EgainStore from '../../stores/EgainStore';
import { GenericModal } from 'web-ui-components/lib/layout/content';

class ChatTile extends React.Component {
  constructor() {
    super();
    this.initiateChat = this.initiateChat.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.onChatClick = this.onChatClick.bind(this);
    this.onHideChatModal = this.onHideChatModal.bind(this);
    this.state = {
      showModal: false,
      saml: '',
      egainChat: UserManagementStore.isSMEUser() ? getSMEChat() : getChat(),
    };
  }

  componentDidMount() {
    EgainStore.addChangeListener(this.onStoreChange);
  }

  componentWillUnmount() {
    EgainStore.removeChangeListener(this.onStoreChange);
  }

  onChatClick() {
    try {
      window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
    } catch (error) {
      window.dtrum?.reportError(error);
    }
    this.onHideChatModal();
  }

  onStoreChange() {
    const token = EgainStore.getSamlToken();
    if (this.state.saml !== token) {
      this.setState({
        saml: token,
      });
    }
  }

  initiateChat() {
    EgainActionCreator.getSamlToken();
    this.setState({
      showModal: true,
    });
  }

  onHideChatModal() {
    this.setState({ showModal: false });
  }

  render() {
    const {
      chatHeading,
      chatDescription,
      eGainChatModelHeader,
      eGainChatModelButtonText,
      eGainChatModelText,
    } = this.props.content;
    const { showModal } = this.state;
    return (
      <div className="c-slab c-slab--tile c-slab--icon--tile l-tile">
        <div className="c-slab__top-wrap">
          <SvgIcon
            className="c-slab__icon"
            id="icon-chat"
            width="64px"
            height="64px"
          />
          <h3 className="c-slab__title">
            <a
              className="c-slab__link"
              href="javascript:;"
              onClick={this.initiateChat}
            >
              {chatHeading}
            </a>
          </h3>
        </div>
        <p className="c-slab--text--bottom">{chatDescription}</p>
        {showModal && (
          <GenericModal
            titleText={eGainChatModelHeader}
            onConfirm={this.onChatClick}
            isOpen={showModal}
            onClose={this.onHideChatModal}
            confirmButtonText={eGainChatModelButtonText}
            isCentred
          >
            <p>{eGainChatModelText}</p>
          </GenericModal>
        )}
      </div>
    );
  }
}

ChatTile.propTypes = {
  content: PropTypes.object,
};

export default ChatTile;
